import * as Sentry from "@sentry/browser";

export default function () {
    Sentry.init({
        dsn: "https://a03722bcef2ee84d0a41fce5e1544f22@o4508301465288704.ingest.us.sentry.io/4508301469089792",
        integrations: [
            Sentry.browserTracingIntegration(),
            // Sentry.replayIntegration({
            //   blockAllMedia: false,
            //   maskAllText: false,
            //   mask: ['[data-pii]','.welcome', '#my-data', '#dashboard', '#order-history', '#my-returns', '#my-addresses', '#account-settings']
            // }),
        ],
        ignoreErrors: [
            "Load failed",
            /^SecurityError.*/,
            "Failed to fetch",
            "NetworkError",
            "Error: Retry count of 5 exceeded..",
            "window.webPixelsManager.init",
            "Missing buildProductGridItem",
            "load error: https://www.lucchese.com/cdn/shopifycloud/media-analytics/v0.1/analytics.js",
            "Monorail Edge",
            "y[t] is not a function",
            /FirebaseError.*/,
            "NotFoundError",
            "AbortError",
            "Invalid call to runtime.sendMessage",
            "Indexed Database",
            "IDBDatabase",
            "Connection is closing",
            "TelemetryExportError",
        ],
        sampleRate: 0.15,
        denyUrls: [
            "worker.modern.js",
            "gtm.js",
            "variant-swatch-king",
            "onsite.js",
            "signpanda",
            "directededge",
            "storefront-banner.js",
            "loudcrowd",
            "startup.bundle",
            "onsite",
            "perf-kit",
            "affirm",
            "boost-pfs",
            "start-tracking",
            "teads-fellow",
            "browser-perf",
            // 'globo',
            "inside-graph",
        ],
        // Tracing
        tracesSampleRate: 0.001,
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", /^(?!www\.)[^.]+\.lucchese\.com/],
        // Session Replay
        // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}
